<template>
  <div class="contato">
    <section class="contato-hero">
      <div class="container" data-aos="fade-up">
        <h1>Entre em Contato</h1>
        <p>Estamos prontos para atender você</p>
      </div>
    </section>

    <section class="contato-content">
      <div class="container">
        <div class="contato-grid">
          <div class="contato-info" data-aos="fade-right">
            <h2>Informações de Contato</h2>
            <div class="info-item">
              <i class="fas fa-envelope"></i>
              <div>
                <h3>Email</h3>
                <a href="mailto:llyonengenharia@gmail.com">llyonengenharia@gmail.com</a>
              </div>
            </div>
            <div class="info-item">
              <i class="fab fa-instagram"></i>
              <div>
                <h3>Instagram</h3>
                <a href="https://instagram.com/llyonengenharia" target="_blank">@llyonengenharia</a>
              </div>
            </div>
            <div class="info-item">
              <i class="fab fa-whatsapp"></i>
              <div>
                <h3>WhatsApp</h3>
                <a href="https://wa.me/11957450292" target="_blank">(11) 95745-0292</a>
              </div>
            </div>

            <div class="horario-atendimento">
              <h3>Horário de Atendimento</h3>
              <p>Segunda a Sexta: 8h às 18h</p>
              <p>Sábado: 8h às 13h</p>
              <p>Domingo: Fechado</p>
            </div>
          </div>

          <div class="contato-form" data-aos="fade-left">
            <h2>Envie sua Mensagem</h2>
            <form @submit.prevent="enviarMensagem">
              <div class="form-group">
                <label for="nome">Nome Completo</label>
                <input type="text" id="nome" v-model="form.nome" required>
              </div>

              <div class="form-group">
                <label for="telefone">Telefone</label>
                <input type="tel" id="telefone" v-model="form.telefone" required>
              </div>

              <div class="form-group">
                <label for="servico">Serviço Desejado</label>
                <select id="servico" v-model="form.servico" required>
                  <option value="">Selecione um serviço</option>
                  <option value="laudo-art">Laudo e ART</option>
                  <option value="seguranca">Segurança e Normas</option>
                  <option value="responsabilidade">Responsabilidade Técnica</option>
                  <option value="exaustao">Exaustão e Bombeiros</option>
                  <option value="climatizacao">Climatização</option>
                  <option value="outro">Outro</option>
                </select>
              </div>

              <div class="form-group">
                <label for="mensagem">Mensagem</label>
                <textarea id="mensagem" v-model="form.mensagem" rows="5" required></textarea>
              </div>

              <button type="submit" class="submit-button">Enviar Mensagem pelo WhatsApp</button>
            </form>
          </div>
        </div>
      </div>
    </section>

    <section class="mapa-section">
      <div class="container">
        <h2 data-aos="fade-up">Nossa Localização</h2>
        <div class="mapa-container" data-aos="fade-up">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d467692.0488667193!2d-46.92450769725324!3d-23.681434535754536!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce448183a461d1%3A0x9ba94b08ff335bae!2sS%C3%A3o%20Paulo%2C%20SP!5e0!3m2!1spt-BR!2sbr!4v1710892177099!5m2!1spt-BR!2sbr"
            width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy"
            referrerpolicy="no-referrer-when-downgrade">
          </iframe>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Contato',
  data() {
    return {
      form: {
        nome: '',
        telefone: '',
        servico: '',
        mensagem: ''
      }
    }
  },
  methods: {
    enviarMensagem() {
      // Formata a mensagem para o WhatsApp
      const mensagemWhatsApp = `Olá! Me chamo ${this.form.nome}.\n\nTelefone: ${this.form.telefone}\nServiço: ${this.form.servico}\n\nMensagem: ${this.form.mensagem}`;

      // Codifica a mensagem para URL
      const mensagemCodificada = encodeURIComponent(mensagemWhatsApp);

      // Número do WhatsApp (remova espaços e caracteres especiais)
      const numeroWhatsApp = '11957450292';

      // Cria o link do WhatsApp
      const linkWhatsApp = `https://wa.me/${numeroWhatsApp}?text=${mensagemCodificada}`;

      // Abre o WhatsApp em uma nova aba
      window.open(linkWhatsApp, '_blank');

      // Limpa o formulário
      this.form = {
        nome: '',
        telefone: '',
        servico: '',
        mensagem: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.contato {
  .contato-hero {
    background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), #2c3e50;
    background-size: cover;
    background-position: center;
    height: 40vh;
    display: flex;
    align-items: center;
    text-align: center;
    color: white;

    .container {
      max-width: 800px;
      margin: 0 auto;
      padding: 0 1rem;

      h1 {
        font-size: 3rem;
        margin-bottom: 1rem;
      }

      p {
        font-size: 1.2rem;
      }
    }
  }

  .contato-content {
    padding: 5rem 0;
    background-color: var(--light-bg);

    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 1rem;
    }

    .contato-grid {
      display: grid;
      grid-template-columns: 1fr 2fr;
      gap: 4rem;
    }

    .contato-info {
      h2 {
        color: var(--primary-color);
        margin-bottom: 2rem;
      }

      .info-item {
        display: flex;
        align-items: flex-start;
        margin-bottom: 2rem;

        i {
          font-size: 1.5rem;
          color: var(--secondary-color);
          margin-right: 1rem;
          margin-top: 0.3rem;
        }

        h3 {
          margin-bottom: 0.5rem;
          color: var(--primary-color);
        }

        a {
          color: var(--text-color);
          text-decoration: none;
          transition: color 0.3s ease;

          &:hover {
            color: var(--secondary-color);
          }
        }
      }

      .horario-atendimento {
        margin-top: 2rem;
        padding-top: 2rem;
        border-top: 1px solid #ddd;

        h3 {
          color: var(--primary-color);
          margin-bottom: 1rem;
        }

        p {
          margin-bottom: 0.5rem;
        }
      }
    }

    .contato-form {
      background: white;
      padding: 2rem;
      border-radius: 10px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

      h2 {
        color: var(--primary-color);
        margin-bottom: 2rem;
      }

      .form-group {
        margin-bottom: 1.5rem;

        label {
          display: block;
          margin-bottom: 0.5rem;
          color: var(--primary-color);
          font-weight: 500;
        }

        input,
        select,
        textarea {
          width: 100%;
          padding: 0.8rem;
          border: 1px solid #ddd;
          border-radius: 5px;
          font-size: 1rem;
          transition: border-color 0.3s ease;

          &:focus {
            outline: none;
            border-color: var(--secondary-color);
          }
        }

        textarea {
          resize: vertical;
        }
      }

      .submit-button {
        display: inline-block;
        padding: 1rem 2rem;
        background-color: var(--secondary-color);
        color: white;
        text-decoration: none;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        transition: background-color 0.3s ease;

        &:hover {
          filter: brightness(90%);
        }
      }
    }
  }

  .mapa-section {
    padding: 5rem 0;

    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 1rem;
    }

    h2 {
      text-align: center;
      color: var(--primary-color);
      margin-bottom: 2rem;
    }

    .mapa-container {
      border-radius: 10px;
      overflow: hidden;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }
  }
}

@media (max-width: 768px) {
  .contato {
    .contato-hero {
      .container {
        h1 {
          font-size: 2.5rem;
        }
      }
    }

    .contato-content {
      padding: 3rem 0;

      .contato-grid {
        grid-template-columns: 1fr;
        gap: 2rem;
      }

      .contato-info {
        .info-item {
          margin-bottom: 1.5rem;
        }

        .horario-atendimento {
          margin-top: 1.5rem;
          padding-top: 1.5rem;
        }
      }

      .contato-form {
        padding: 1.5rem;

        .form-group {
          margin-bottom: 1rem;

          input,
          select,
          textarea {
            padding: 0.6rem;
          }
        }
      }
    }

    .mapa-section {
      padding: 3rem 0;

      .mapa-container {
        iframe {
          height: 300px;
        }
      }
    }
  }
}
</style>